<template>

<div class="container-fluid"> 

    <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>

    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />



<promoCouponIdentification v-if="promoCoupon" @close="promoCoupon=false" @update="setTotalByPromoCoupon"  v-bind:total="total"></promoCouponIdentification>
<cleanTotal v-if="modalCleanTotal" @update="setTotal" :key="refresh" v-bind:props="checkOut"></cleanTotal> 
<div class="card border-primary bg-light text-dark">

  <div  class="card-header  text-white bg-primary ">
  <h4> 
    <i style="color:#DFFF00" class="fas fa-cash-register mr-3" aria-hidden="true"></i>PAGAMENTO</h4>    
  </div> 
  
  <div  class="card-body">           
    <div class="row">      
      
      <div class="col-md-3"></div> 

      <div class="card border card_border border-success col-md-6" >
      
      <div  v-if="subtotal > total"> 
        <span class="border border-dark rounded ml-1 subtotal">
         <strong class="ml-3 mr-3">SUBTOTALE € {{ fmt1(Number(subtotal))}}</strong>
        </span>
      </div>
      
      <div  v-else> 
       
        
      </div>    

      <div class="card-header_ text-center_ border border-success rounded bg-success bar text-black p-1">

        <span class="total float-left ml-4">TOTALE € {{ fmt1(Number(total))}} </span > 
          <span class="float-right mr-2 mt-2 total2">
          <strong class="ml-3">TOTALE ARTICOLI 
            <span class="badge badge-pill badge-dark ml-2">{{ cart.length }}</span>
            </strong>
        </span> 
      

    </div>

    <div class="card-body">
     
      <div v-if="marketPlaceList.length > 0" class="mb-4">  
      <label for="marketPlace"><strong>PROVENIENZA VENDITA/RESO</strong></label>
      <select  class="form-control" v-model="saleTypeId" >
      <option value="0" >RETAIL</option>
      <optgroup label="MARKET-PLACE">  
        <option v-for="(item,index) in marketPlaceList" :value="item.MarketPlaceId" :key="index">{{item.MarketPlace}}</option>        
      </optgroup>
      </select>
      </div>

      <div class="mt-4">
      <span style="color : #800000">
        <i class="fas fa-user mr-2" aria-hidden="true"></i>
        <strong> {{customer}}  </strong></span>

          <span v-if="cb" style="color:green ">  - CASHBACK  <strong>{{ fmt1(Number(cb))}} € </strong> </span> 
      </div>


      <div class="form-group mt-3 mb-3">
      <span for="inputAbbuono" class="col-form-label">
       <!-- <i style="color:red" class="far fa-minus-square mr-3" aria-hidden="true"></i> -->
        <strong style="font-size: 20px;">ABBUONO DI CASSA</strong>
      
      </span>
      <div>
      
      </div>

      <div class="input-group">
        <div class="input-group-prepend">
            <div class="input-group-text">€</div>
          </div>
        <input @focus="editSubTotal()"  @input="updateTotal()" type="number" step="0.01" :style="{fontSize: '20px',borderWidth : discount > 0 ? 'solid':'',  borderColor: discount > 0 ? 'red':''}" class="form-control" id="inputAbbuono" placeholder="Abbuono" v-model="discount">
        <button  @click="editSubTotal()" class="btn btn-warning float-left" data-toggle="tooltip" title="Modifica totale vendita">
            <i  class="fas fa-edit" aria-hidden="true"></i>
        </button>
      </div>
      <span v-if="discount!=0" style="color:red ">  - SCONTO   <strong>{{ total_discount_percentage}} % </strong> </span> 
    </div>
    <button @click="promoCoupon=true" type="button" class="btn btn-link">
            <strong>COUPON PROMO</strong>              
            <i v-if="promoCouponId" :style="{color:'green'}" class="far fa-check-circle ml-3" aria-hidden="true"></i>
      </button>
    
    
  <h4 v-if="Number(total) >=0 "  class="text-center mt-3"><strong>IMPORTO DA PAGARE   <span class="ml-3" :style="{color:'green',fontSize:'28px'}" >  € {{ fmt1(Number(total) -  Number(discount)) }} </span> </strong>  </h4> 
  <h4 v-if="Number(total) < 0 "  class="text-center mt-3"><strong>IMPORTO DA PAGARE   <span class="ml-3" :style="{color:'green',fontSize:'28px'}" >  € {{ fmt1(Number(total) -  Number(discount*-1)) }} </span> </strong>  </h4> 

  <!-- CASH -->

  <!-- CREDIT NOTE BUTTON-->
  <creditNoteBtn class="mt-1 mb-2" @update="setTotalRefund" ></creditNoteBtn>
  
  <div class="form-group">    
    <div class="input-group">
        <div class="input-group-prepend">           
          <div  style="background-color : #339900;color:white;width:150px" class="input-group-text cash rounded"><strong>CONTANTE</strong>  </div>
          <span class="input-group-text"> €</span>
        </div>

      <input v-focus ref="inputCash" type="number" step="0.01"  :style="{fontSize: '30px'}" class="form-control" id="inputCash" placeholder="Contante" v-model="cash">
      
      <button  @click="swap('CASH')" class="btn btn-info float-left" data-toggle="tooltip" title="passa importo ad elettronico">
      <i  class="fas fa-sync-alt" aria-hidden="true"></i>
      </button>
 
  </div>
  <small style="color:red" v-if="cash < 0">
       <strong> L'IMPORTO NEGATIVO VERRA' ADDEBITATO SUL TOTALE CASSA DEL GIORNO, DIGITARE ZERO PER NON MODIFICARE LA CASSA.</strong>  
      </small>

  </div>
 

    <!-- ELEC -->
    <div class="form-group">
      
      <div class="input-group">
        <div class="input-group-prepend">
            <!--<span class="input-group-text"> <i  class="far fa-credit-card " aria-hidden="true"></i></span>-->

            <div style="background-color:#FF6600;color:black;width:150px" class="input-group-text elec rounded"><strong>ELETTRONICO</strong></div>
            <span class="input-group-text"> €</span>
          </div>
        <input type="number" step="0.01"  :style="{fontSize: '30px'}" class="form-control" id="inputElettronico" placeholder="Elettronico" v-model = "electronic">
        
        <button  @click="swap('ELEC')" class="btn btn-info float-left"
        data-toggle="tooltip" title="passa importo a contante"
        >
      <i  class="fas fa-sync-alt" aria-hidden="true"></i>
    </button>

      </div>
      <small style="color:red" v-if="electronic < 0">
       <strong> L'IMPORTO NEGATIVO VERRA' ADDEBITATO SUL TOTALE CASSA DEL GIORNO, DIGITARE ZERO PER NON MODIFICARE LA CASSA.</strong>  
      </small>

    </div>


  <!-- COUPON -->
  <div class="form-group">
    
    <div class="input-group">
        <div class="input-group-prepend">
          <!--<span class="input-group-text"> <i class="fas fa-award mr-1" aria-hidden="true"></i></span>-->
          <div style="background-color:goldenrod;color:white;width:150px" class="input-group-text coupon rounded"><strong>COUPON</strong></div>
            <span class="input-group-text"> €</span>
        </div>
      <input type="number" step="0.01"  :style="{fontSize: '30px'}" class="form-control" id="inputCoupon" placeholder="Coupon" v-model = "coupon">


      <button  @click="initCouponIdentification()" class="btn btn-primary float-left"
        data-toggle="modal" title="Identificazione coupon"  >
        <i  class="fas fa-search-dollar" aria-hidden="true"></i>
      </button>



    </div>
        
            <table class="table table-sm ">
            <tr v-for="(item, index) in couponArray">
            <td>
              {{ index + 1 }}
            </td>
            <td>
              {{ item.barcode }}
            </td>
            <td class="text-right">
              <strong> {{ fmt1(item.total)}}</strong>
            </td>
            <td>
              <button class="btn btn-secondary btn-sm"  title="rimuovi coupon" v-on:click=" removeCoupon(item.total,index)">X</button>   
            </td>
            </tr>
          </table>  
                
    </div>
  
  

  <!-- CASHBACK -->
  <div v-if="cb" class="form-group">
      
      <div class="input-group">
        <div class="input-group-prepend">
            <!--<span class="input-group-text"> <i class="fas fa-wallet" aria-hidden="true"></i></span>-->
            <div style="background-color:#800000 ;color:white;width:150px" class="input-group-text rounded"><strong>CASHBACK</strong></div>
            <span class="input-group-text"> €</span>
          </div>
        <input type="number" step="0.01"  :style="{fontSize: '30px'}" class="form-control" id="inputCashback" placeholder="Cashback" v-model = "cashback">
        <button  @click="setCashbackInput()" class="btn btn-info float-left"
        data-toggle="modal" title="Usa cashback cliente"  >
      <i  class="fas fa-check" aria-hidden="true"></i>
    </button>
    </div>
    </div>

     <!-- OTHER PAYMENT-->  
    <OtherPayment  @update="setOtherPayment"></OtherPayment>  

    <hr>

    <!-- NOT PAID -->
    <div class="row">
    <div class="col">  
    <div class="input-group ">
          <div class="input-group-prepend" >
            <div :style="{fontSize: '20px',borderWidth : notPaid != 0 ? 'solid':'',  borderColor: notPaid != 0 ? 'red':''}"    :hidden="notPaid<=0" style="width:150px" class="input-group-text"><strong>NON PAGATO €</strong></div>
          </div>
          <span class="ml-3" :hidden="notPaid<=0"  :style="{color: notPaid != '0.00'  ? 'red' :  'black', fontSize: '30px'}"><strong>{{fmt1(notPaid)}}</strong></span>    
    </div>
    </div>
    
    <div class="input-group mt-1 ml-3">
          <div class="input-group-prepend">
            <div style="width:150px" class="input-group-text rounded"><strong>RESTO €</strong></div>
          </div>
          <span class="ml-3" :style="{color: rest < 0  ? 'blue' :  'black', fontSize: '30px'}"><strong>{{fmt1(Math.abs(rest))}}</strong></span>    
    </div>

    <div v-if="1==0" class="col ">
    
    <div class="input-group ">
          <div class="input-group-prepend">
            <div style="width:150px" class="input-group-text "><strong>RESTO €</strong></div>
          </div>
          <span class="ml-3" :style="{color: rest < 0  ? 'blue' :  'black', fontSize: '30px'}"><strong>{{fmt1(Math.abs(rest))}}</strong></span>    
    </div>

    </div>

    </div>
    
   <printButton v-bind:props="printButton"></printButton>


  <!-- COL --> 

  <!----> 


    </div>
    </div>

<div class="col-md-3"></div> 

<!-- ROW-->
</div>


</div>

<div class="card-footer border-primary bg-transparent">
 
  <alert-box class="mt-1 mb-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  <button v-if="!bt_spinner" @click="$emit('cancel')"  class="btn btn-secondary btn-lg float-left  ml-2">
   <i style="color:yellow" class="fas fa-reply mr-3" aria-hidden="true"></i>
    RITORNA AL CARRELLO
  </button>

  <button  @click="checkPayments()"  class="btn btn-primary  btn-lg float-right  mr-2">
    <i style="color:yellow" class="far fa-play-circle mr-2" aria-hidden="true"></i>
    ESEGUI VENDITA
    
  </button>



</div>  

</div>


<couponIdentification @update="setCoupon"></couponIdentification>  

</div>


</template>

<script>

import api                   from "@/api"
import axios                 from "axios"
import { mapGetters }        from 'vuex'
import alertBox              from '@/components/common/AlertBox.vue'
import couponIdentification  from '@/components/frontOffice/coupon/CouponIdentification.vue' 
import cleanTotal            from '@/components/frontOffice/checkOut/cleanTotal.vue' 
import OtherPayment          from "@/components/frontOffice/checkOut/OtherPaymentTest.vue";
import fmt                   from '@/components/mixins/fmt.js'



import printButton           from '@/components/frontOffice/checkOut/PrintButton.vue' 
import creditNoteBtn         from '@/components/frontOffice/checkOut/CreditNoteRefund.vue' 
import promoCouponIdentification  from '@/components/frontOffice/PromoCoupon/PromoCouponIdentification.vue'



import modalMessage               from '@/components/modalDialog/ModalMessage.vue'      
import modalConfirm               from '@/components/modalDialog/ModalConfirm.vue'   


import { v4 as uuidv4 }           from 'uuid'

export default {
 mixins : [fmt], 
 props  : ['checkOut'],
components: { alertBox, couponIdentification, cleanTotal, OtherPayment,printButton,creditNoteBtn,promoCouponIdentification,modalMessage,modalConfirm },
  data () {
    return {
     
      total_refund : 0,

      

      total_discount_percentage : 0.00,
      customerId   : 0,
      customer     : '',
      cb           : 0,
      saleTypeId   : 0,
      deskId       : 1,
      subtotal     : 0,
      total        : 0.00,
      discount     : 0,
      cash         : 0,
      electronic   : 0, 
      coupon       : 0,
      cart         : [],
      payment      : [],
      printReceipt : 0,

      rt           : {},
      couponId     : 0,
      couponBarcode : '', 
      cashback      : 0,
      

      msg          : {
       title       : ''
      },
      marketPlaceList : [],
      
      bt_spinner   : false,
     
      stockUpdate  : false,
      

      saleId          : 0,
      refresh         : 0,
      modalCleanTotal : false,
      TotalDiscount   : 0,
      couponArray     : [],

      otherPayment    : {
        total : 0.00,
        type : '',
        payments : []
      },
      fiscalPrinter   : {

        component     : 'FiscalReceipt'

      },
      promoCoupon     : false,
      promoCouponId   : 0,
    
      uuid            : ''
      
      

      
      

    }
  },
  directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()
          el.select()
          }
       
      }
    },
  computed: 
  {
   ...mapGetters(['storeId','company','custGroupId']) ,  

  printButton : function()
  {
    const btn         = {}
    btn.cart          = this.cart
    btn.total         = this.total
    btn.discount      = this.discount
    btn.storeId       = this.storeId
    btn.deskId        = this.deskId
    btn.percentage    = this.total_discount_percentage
    return btn
  },

  notPaid : function()
  {
  
    //const total1 = Number(this.total)  - Number(this.discount)
    const discount = Number(this.total < 0) ? Number(this.discount * -1) : Number(this.discount)
    const total1 = Number(this.total) - Number(discount)
    
    
    
    const total2 =  Number(this.cash) + Number(this.electronic) + Number(this.coupon) + Number(this.cashback) + Number(this.otherPayment.total) + Number(this.total_refund)
    const total  = Number(total1.toFixed(2)) - Number(total2.toFixed(2))
    
    return Number(total.toFixed(2))

  },
  rest : function()
  {
    const total = this.total - this.discount - this.cash - this.total_refund
    if(this.total - this.discount > 0)
    {
      return Number(total.toFixed(2)) < 0 ? Number(total.toFixed(2)) : 0
    }
    else
    {
      return 0
    }
  },
  balance : function()
  {
      //console.log('BAL',this.notPaid - this.rest)
      return (this.notPaid - this.rest)
  }
     
  },
  mounted() 
  {
    
    
  },  
  async created()
  {
    
     
    this.uuid  = uuidv4()
    this.getStoreFiscalPrinter()
    this.getMarketPlaceList()
    this.getCart()

   
  },
  methods: 
  {





    setTotalByPromoCoupon(total,rowId)
    {
      this.promoCoupon = false

      if(total)
      {
       
        const discount                  = this.total - total 
        this.discount                   = Math.abs(discount).toFixed(2)
        this.cash                       = total.toFixed(2)       
        const total_discount            = 100 - (total / this.total * 100)
        this.total_discount_percentage  = total_discount.toFixed(2)
        this.promoCouponId              = rowId
        
      }
      this.$nextTick()
                  .then(() => {

                    this.$refs.inputCash.focus()
                    this.$refs.inputCash.select()
                    
                  })



    },

    setTotalRefund(total)
    {
      
      this.total_refund = total
      const cash =  Number(this.total) - Number(this.discount) - Number(this.total_refund)
      this.cash = cash.toFixed(2)

    },


    setOtherPayment(payments)
    {

      
      let total = 0
      payments.forEach(item => {
        console.log(item)
        total += Number(item.total)
      })
      this.otherPayment.total = total      
      this.otherPayment.payments = payments  
      
      
    },
    editSubTotal()
    {
      this.modalCleanTotal = true
      
      this.$nextTick()
                  .then(() => {
                          $('#modalCleanTotal').modal('show')
                 })
      

    },


    setCashbackInput()
    {
      
      this.cashback = this.cb.toFixed(2)
      
    },
    setTotal(total,discount_percentage)
    {
      
      $('#modalCleanTotal').modal('hide');
      this.modalCleanTotal = false
      if(total)
      {
       
        const discount                  = this.total - total 
        this.discount                   = Math.abs(discount).toFixed(2)
        this.cash                       = total        
        this.total_discount_percentage  = discount_percentage
        
      }
      this.$nextTick()
                  .then(() => {

                    this.$refs.inputCash.focus()
                    this.$refs.inputCash.select()
                    
                  })
      
      

    },
    setCoupon(coupon)
    {
      
      // check barcode
      let index = 0
      this.couponArray.forEach(item =>{
        if(item.barcode == coupon.barcode)
        {
          index++
        }
      })
      if(index==0)
      {
        this.couponArray.push({'barcode' : coupon.barcode,'total':coupon.total,'couponId':coupon.couponId})
        
        this.coupon = Number(this.coupon) + Number(coupon.total)
      }

      
      //$('#CouponIdentification').modal('hide');

    },
    removeCoupon(item_total,index)
    {
      this.couponArray.splice(index, 1) 
      const coupon = Number(this.coupon)
      const total = Number(coupon) - Number(item_total)
      this.coupon = total == 0 ? '0.00' : total
      


    },
    initCouponIdentification()
    {
      $('#CouponIdentification').on('shown.bs.modal', function (event) {
      $('#couponBarcode').val('')
      $('#couponBarcode').trigger('focus');
    })

    $('#CouponIdentification').modal({keyboard: false,backdrop:'static'});
  },  
  
    async getStoreFiscalPrinter()
    {
      const sp    = {'sp' : 'spStoreFiscalPrinter'}
      const data  = {'storeId' : this.storeId,'deskId':this.checkOut.deskId}
      
      const json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            if(res.data.recordsets[0].length > 0)
            {
              this.fiscalPrinter = res.data.recordsets[0][0]
            }
            this.rt =  res.data.recordsets[0][0]    
            if(this.rt)
            {
              this.printReceipt = this.rt.active 
              this.component = this.rt.type
            }

          }
          else if(res.status==500)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        //this.spinner = false
      });

  
    },
  
    rt_test(data)
    {   
        

        return new Promise( async (resolve, reject)  =>  {

        axios({
                url    : this.rt.url,
                method : this.rt.method,
                data   : data
              }).then(res => {
                console.log('RT Test Response',res)
                resolve({'data':res})
              }).catch( err =>{
                console.log('RT Test Error',err)
                resolve({'data':err})
              })
        })       

    },
  
    swap(payment)
    {
      if(payment=='CASH')
      {
        this.electronic = this.cash 
        this.cash = '0.00'
      }
      else
      {
        this.cash = this.electronic
        this.electronic = '0.00'
      }
    },  
   
    async getMarketPlaceList()
    {
      var sp    = {'sp':'spCompanyMarketPlace'}
      var data  = {'companyId' : this.company.Id}
     
      var json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.marketPlaceList =  res.data.recordsets[0]         
          }
          else if(res.status==500)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        //this.spinner = false
      });

  

    },
    getCart()
    { 
      
      this.customerId   =  this.checkOut.customerId
      this.customer     =  this.checkOut.customer
      this.cb           =  this.checkOut.cb

      this.cart         = this.checkOut.rows
      this.total        = this.checkOut.total
      this.subtotal     = this.checkOut.subtotal

      const cash        = this.total
      this.cash         = cash.toFixed(2)
      
      this.discount     = this.discount.toFixed(2)
      this.electronic   = this.electronic.toFixed(2)
      
      this.coupon       = this.coupon.toFixed(2)
      this.deskId       = this.checkOut.deskId

      this.cashback    = this.cashback.toFixed(2)


      this.otherPayment.total = this.otherPayment.total.toFixed(2)

      this.refresh++
      
    },
    updateTotal()
    {
        this.total_discount_percentage = 0
        if(this.discount >0)
        {
          
          let total = 0.00
          const netTotal = this.total - this.discount
          const subTotal = (netTotal / this.total) * 100.00
          total = 100.00 - subTotal
          
          this.total_discount_percentage = Number(total.toFixed(2))

        }  



      const cash  = Number(this.total  - this.discount)
      this.cash = cash.toFixed(2)
      
    },

    
    async checkFormat()
    {
 
      if(!this.cash)
      {
     
       
        const msg = 'Formato importo CONTANTE non corretto.\n Inserire un IMPORTO oppure ZERO.'      
        await this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)       
        return false

      }
      
      
      if(!this.electronic)
      {
        
        const msg = 'Formato importo ELETTRONICO non corretto.\n Inserire un IMPORTO oppure ZERO.'      
        await this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)
        return false
      }

      if(!this.coupon)
      {

        
        const msg = 'Formato importo COUPON non corretto.\n Inserire un IMPORTO oppure ZERO.'      
        await this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)
        return false
        
      }
      if(!this.cashback)
      {
      
        const msg = 'Formato importo CASHBACK non corretto.\n Inserire un IMPORTO oppure ZERO.'      
        await this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)        
        return false

      }

      // DA VERIFICARE
      if(!this.otherPayment.total)
      {
        
      }

      if(this.cb)
      {
        if(Number(this.cashback) > Number(this.cb.toFixed(2)))
        {
          
            const msg = 'Importo CASHBACK maggiore del CASHBACK CLIENTE.'      
            await this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)
            return false
        }
      }

      const total = Number(this.total) - Number(this.discount)
      if(Number(total.toFixed(2)) > 0)
      {
               
        const subtotal = (Number(this.cash) - Number(Math.abs(this.rest))) + Number(this.electronic) + Number(this.coupon) + Number(this.cashback) + Number(this.otherPayment.total) + Number(this.total_refund)
        console.log('SUBTOTAL',subtotal.toFixed(2))

        if( Number(subtotal.toFixed(2)) > Number(total.toFixed(2)) )
        {
           
            const msg = 'Totale PAGATO maggiore del totale VENDITA.'
            await this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)
            return false  

        }
        
      }
      if(this.total < 0)
      {
        if(this.discount > 0)
        {
          
        }
        
        if(Number(this.cash) + Number(this.electronic) + Number(this.coupon) + Number(this.cashback) + Number(this.otherPayment.total) > 0)
        {
          
            const msg = 'IL TOTALE CASSA DEVE ESSERE NEGATIVO OPPURE UGUALE A ZERO.'
            await this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)
            return false  
          

          
        }
      }


      return true
    },


   async checkTotalPaid()
   {


      const total = Number(this.total) - Number(this.discount)      
      if(Number(total.toFixed(2)) > 0)
      {
               
        const subtotal = (Number(this.cash) - Number(Math.abs(this.rest))) + Number(this.electronic) + Number(this.coupon) + Number(this.cashback) + Number(this.otherPayment.total) + Number(this.total_refund)
        
        if( Number(subtotal.toFixed(2)) < Number(total.toFixed(2)) )
        {
          
          const confirmed=  await this.$refs.confirmModal.show(
          'TOTALE INCASSATO INFERIORE AL TOTALE CARRELLO.\nPROCEDO COMUNQUE ?',
          { title: 'ATTENZIONE ' },3
          )

            if (!confirmed) return false
            this.$refs.confirmModal.close()                   

        }
        
      }
      return true
      
   }, 

   async checkPayments()
   {
    
       
      const confirm1 = await this.checkFormat()
      if(!confirm1) return
     
      const confirm2 = await this.checkTotalPaid()
      if(!confirm2) return

      this._checkOut()


   },


/*
   async  _checkOutCopyGood()
    { 
                
      this.msg.title = '' 

      
      


      this.bt_spinner = true
      const arrData  = []

      

      this.cart.forEach(item=>{

        arrData.push({
        'productId'      : item.productId,  
        'barcode'        : item.barcode,
        'qty'            : item.qtyOnSale,
        'price'          : item.price,
        'discount'       : item.discount,
        'vat'            : item.vat,
        'assistant_code' : item.assistant_code, 
        'rowType'        : item.type == true ? 1 : 0,
        'price_saved'    : item.price_saved,
        'discount_saved' : item.discount_saved,
        'rowTotal'       : Math.abs(item.rowTotal)})
      })  

      // NEW FISCAL PRINTER SET SALE OR CREDIT NOTE 


      this.fiscalPrinter.component = this.setFiscalComponent(arrData)

      const data   = {}
            
      data.header  = {}
      data.body    = {}
      data.payment = {}
      data.coupons = {}

      data.header.companyId                 = this.company.Id
      data.header.storeId                   = this.storeId
      data.header.deskId                    = this.deskId
      data.header.total                     = this.total
      data.header.discount                  = this.discount
      data.header.customerId                = this.customerId
      data.header.printTicket               = this.printReceipt == true ? 1 : 0
      data.header.saleTypeId                = this.saleTypeId
      data.header.balance                   = this.balance
      data.header.round_total               = this.checkOut.round_total
      data.header.custGroupId               = this.custGroupId
      data.header.total_discount_percentage = this.total_discount_percentage   
      data.header.promoCoupon_rowId         = this.promoCouponId   
      data.payment                          = this.dataPayment()
      data.body                             = arrData
      data.coupons                          = this.couponArray 
    
      

      const sp       = {'sp':'spCreateSale'}      
      const json     = Object.assign(data, sp);
      
      this.waitModal.show  = true      
      await api.post(json).then(async res =>  {
        if(res.status==200)
        { 
          
          this.waitModal.sentinel = 1          
          this.saleId = res.data.recordsets[0][0].saleId    

          console.log('SYNC STOCK FLAG',this.company.sync_stock)


          // SYNC STOCK 
          if(this.company.sync_stock == 1)
          {
           
            const data  = {'saleId' : this.saleId,'process_env' : process.env.NODE_ENV }          
            const url   =  process.env.VUE_APP_ROOT_API1 + 'sync/update_stock'    
                  
              axios({
              url    : url,
              method : "post",
              data   : data
              }).then(res => {
                console.log('Update Stock result',res.data)
              }).catch(err => {
                console.log(err)
              })
          

          }
             
              
                const obj = 
                {
                
                  'print_receipt' : this.printReceipt,
                  'saleId'        : this.saleId,
                  'payment'       : this.dataPayment(),
                  'rest'          : this.fmt1(Math.abs(this.rest)),
                  'fp'            : this.fiscalPrinter
                }

                this.$nextTick(()  => {              
                  this.$emit('close',obj)
                    
                })  
                
                    
        }
        else if(res.status==500)
        {
          this.waitModal.sentinel = 3
        
          this.$nextTick()
              .then(() => {
                this.dialogBox.show     = true
                this.dialogBox.title    = ' * ATTENZIONE *'
                this.dialogBox.msg      = res.data
        
        
        })



          
         

        } 
        else
        {
          
          this.waitModal.sentinel = 2
          
          console.log('NO RESPONSE',res)
          
          

        } 
    }).catch(err => 
    {
          this.waitModal.sentinel = 3


          this.$nextTick()
              .then( () => {
                this.dialogBox.show     = true
                this.dialogBox.title    = ' * ATTENZIONE *'
                this.dialogBox.msg      = err.message
        
        
          })


    }).finally(() => {
      this.bt_spinner = false
    });
    

    
    },


*/

async  _checkOut()
    { 
                



      this.bt_spinner = true
      const arrData  = []

      this.cart.forEach(item=>{

        arrData.push({
        'productId'      : item.productId,  
        'barcode'        : item.barcode,
        'qty'            : item.qtyOnSale,
        'price'          : item.price,
        'discount'       : item.discount,
        'vat'            : item.vat,
        'assistant_code' : item.assistant_code, 
        'rowType'        : item.type == true ? 1 : 0,
        'price_saved'    : item.price_saved,
        'discount_saved' : item.discount_saved,
        'rowTotal'       : Math.abs(item.rowTotal)})
      })  

      /* NEW FISCAL PRINTER SET SALE OR CREDIT NOTE */


      this.fiscalPrinter.component = this.setFiscalComponent(arrData)

      const data   = {}
            
      data.header  = {}
      data.body    = {}
      data.payment = {}
      data.coupons = {}

      data.header.companyId                 = this.company.Id
      data.header.storeId                   = this.storeId
      data.header.deskId                    = this.deskId
      data.header.total                     = this.total
      data.header.discount                  = this.discount
      data.header.customerId                = this.customerId
      data.header.printTicket               = this.printReceipt == true ? 1 : 0
      data.header.saleTypeId                = this.saleTypeId
      data.header.balance                   = this.balance
      data.header.round_total               = this.checkOut.round_total
      data.header.custGroupId               = this.custGroupId
      data.header.total_discount_percentage = this.total_discount_percentage   
      data.header.promoCoupon_rowId         = this.promoCouponId   
      data.payment                          = this.dataPayment()
      data.body                             = arrData
      data.coupons                          = this.couponArray 
    
      
      const uuid     = this.uuid  
      const sp       = 'spCreateSaleRequestLog'
      const payload  = {sp,...data,uuid}
      
      //console.log(payload)
      
      this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'},5)  
      try{

          const res = await api.post(payload)
          if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }

          this.saleId = res.data.recordsets[0][0].saleId    

          /* SYNC STOCK */                
          if(this.company.sync_stock == 1)
          {
           
            const data  = {'saleId' : this.saleId,'process_env' : process.env.NODE_ENV }          
            const url   =  process.env.VUE_APP_ROOT_API1 + 'sync/update_stock'    
                  
              axios({
              url    : url,
              method : "post",
              data   : data
              }).then(res => {
                console.log('Update Stock result',res.data)
              }).catch(err => {
                console.log(err)
              })          

          }
                
                const obj = 
                {
                
                  'print_receipt' : this.printReceipt,
                  'saleId'        : this.saleId,
                  'payment'       : this.dataPayment(),
                  'rest'          : this.fmt1(Math.abs(this.rest)),
                  'fp'            : this.fiscalPrinter
                }

                this.$nextTick(()  => {              
                  this.$emit('close',obj)
                    
                })  
                
                    
        }
        catch(err)
        {
            const msg = err.message + '\n' + 'RIPROVARE.'           
            this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)

        }
        

          
        

    
    },







    dataPayment()
    {
      const arr = []
      
      

      if(Number(this.cash) != 0)
      {
        arr.push({'typeId':'CASH','amount' : this.cash  - Math.abs(this.rest) })
      }
      
      // CREDIT NOTE REFUND
      if(Number(this.total_refund > 0))
      {
        if(arr.length == 0)
        {
          arr.push({'typeId':'CASH','amount' : Number(this.total_refund)  })
        }
        else
        {
          
         // const total = arr[0].amount
          
          arr[0].amount = Number(this.cash)  - Math.abs(this.rest) + Number(this.total_refund)
        }

      }

      if(Number(this.electronic) !=0)
      {
        arr.push({'typeId':'ELEC','amount' : this.electronic})
      }
      
      if(this.notPaid > 0)
      {
        
        arr.push({'typeId':'CRED','amount' : this.notPaid})
      }

      if(this.coupon != 0)
      {
        
        arr.push({'typeId':'COUP','amount':this.coupon})
      }
      if(this.cashback != 0)
      {
        
        arr.push({'typeId':'CB','amount':this.cashback})
      }

      if(Number(this.otherPayment.total) != 0)
      {
        this.otherPayment.payments.forEach(item => {
            if(Number(item.total) > 0)
            {
                arr.push({'typeId':item.payment,'amount' : item.total})        
            }
            
        })  
        //arr.push({'typeId':this.otherPayment.type,'amount':this.otherPayment.total})
      }
      

      return arr
    },

    setFiscalComponent(data)
    {
      let fiscalReceipt = 0
      let creditNote    = 0
      data.forEach(item => {
        if(item.rowType == 0 )
        {
          fiscalReceipt++
        }
        else
        {
          creditNote++
        }
      })
      if(fiscalReceipt && creditNote)
      {
        
        return ''
      }
      if(fiscalReceipt)
      {
        return 'FiscalReceipt'
      }
      if(creditNote)
      {
        return 'CreditNote'
      }


    }
    

  }
}
</script>
<style scoped>
.custom-control-label
{
  cursor : pointer;
}
h4,p,span {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.subtotal {
  
  font-family : 'Roboto Condensed';
  font-size   : 22px;
  color       : rgb(22, 13, 189);
  
}
.subtotal1 {
  background-color: antiquewhite;
  font-family : 'Roboto Condensed';
  font-size   : 26px;
  font-weight : bolder;
  color       : rgb(105, 98, 17);
  
}

.left {
  background-image: linear-gradient(to right, rgb(186, 235, 219) ,white);
  
}
.right {
  background-image: linear-gradient(to left, rgb(186, 235, 219)  ,white);
}
.total{
  font-size   : 35px;
  font-weight : bold; 
  color       : rgb(0, 16, 247);
  /*color       : rgb(13, 4, 112);*/
}
.total2{
  font-family : 'Roboto Condensed';
  font-size   : 25px;
  font-weight : bold; 
  color       : rgb(21, 4, 97);
}
.card-header
{
  height: 45px;
}
.btn-warning{
        color           : white; 
        background-color: rgb(103, 33, 233);
      }
.cash{
  background-color:rgb(95, 162, 93) !important
}  
.elec{
  background-color: rgb(246, 129, 71) !important
}
.coupon{
  background-color: rgb(118, 119, 91) !important
}
.bar{
  
  background-color:rgb(156, 186, 242) !important;
  
  border-width: thick !important;
  /*background-color: rgb(150, 151, 163) !important*/

}
.card_border
{

  border-width: thin medium thick 10pxs !important
}
</style>